var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncrementalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.30213C0 1.03604 0.21573 0.820312 0.481818 0.820312H2.3C2.56609 0.820312 2.78182 1.03604 2.78182 1.30213V4.00213H4.11818C4.38427 4.00213 4.6 4.21786 4.6 4.48395C4.6 4.75004 4.38427 4.96577 4.11818 4.96577H2.78182V7.66577C2.78182 7.93186 2.56609 8.14759 2.3 8.14759H0.481818C0.21573 8.14759 0 7.93186 0 7.66577C0 7.39968 0.21573 7.18395 0.481818 7.18395H1.81818V4.96577H0.481818C0.21573 4.96577 0 4.75004 0 4.48395C0 4.21786 0.21573 4.00213 0.481818 4.00213H1.81818V1.78395H0.481818C0.21573 1.78395 0 1.56822 0 1.30213Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrementalIcon);
export default __webpack_public_path__ + "static/media/incrementalIcon.763377e2749675bbfc1b5b9454376169.svg";
export { ForwardRef as ReactComponent };